// What the two customer pages say, in English (book.<key> in i18n/locales/<code>.json
// for every other language; the az/ru here are the dormant originals).
import { sayWord } from '../lib/i18n/catalog'
import type { LanguageCode } from '../lib/i18n/languages'

export type Lang = LanguageCode
/** The languages these words are written in. */
export type Written = 'az' | 'ru' | 'en'
/** The switch before the organisation's own list is read: English first. */
export const LANGS: readonly Lang[] = ['en', 'az', 'ru']
/** The written language a text is said in. */
export const written = (l: Lang): Written => (l === 'az' || l === 'ru' ? l : 'en')

export const WORDS = {
  title: { az: 'Onlayn növbə', ru: 'Онлайн-запись', en: 'Online booking' },
  language: { az: 'Dil', ru: 'Язык', en: 'Language' },
  step: { az: 'Addım {n} / {total}', ru: 'Шаг {n} из {total}', en: 'Step {n} of {total}' },
  pickBranch: { az: 'Filial seçin', ru: 'Выберите отделение', en: 'Choose a branch' },
  pickService: { az: 'Xidmət seçin', ru: 'Выберите услугу', en: 'Choose a service' },
  pickTime: { az: 'Vaxt seçin', ru: 'Выберите время', en: 'Pick a time' },
  pickDay: { az: 'Gün seçin', ru: 'Выберите день', en: 'Choose a day' },
  details: { az: 'Məlumatlarınız', ru: 'Ваши данные', en: 'Your details' },
  enterCode: { az: 'Kodu daxil edin', ru: 'Введите код', en: 'Enter the code' },
  sentTo: { az: 'Göndərildi: {contact}', ru: 'Отправлен на {contact}', en: 'Sent to {contact}' },
  sent: { az: 'Kod göndərildi', ru: 'Код отправлен', en: 'Code sent' },
  noBranches: { az: 'Bron üçün filial yoxdur', ru: 'Нет отделений для записи', en: 'No branches to book' },
  minutes: { az: '{n} dəq', ru: '{n} мин', en: '{n} min' },
  optional: { az: 'İstəyə bağlı', ru: 'Необязательно', en: 'Optional' },
  sendBy: { az: 'Kod hara göndərilsin',ru: 'Куда отправить код', en: 'Send the code by' },
  yourBooking: { az: 'Bronunuz', ru: 'Ваша запись', en: 'Your booking' },
  booked: { az: 'Bron edilib', ru: 'Записан', en: 'Booked' },
  arrived: { az: 'Gəlmisiniz', ru: 'Вы пришли', en: 'Arrived' },
  missed: { az: 'Buraxılıb', ru: 'Пропущено', en: 'Missed' },
  addCalendar: { az: 'Təqvimə əlavə et', ru: 'В календарь', en: 'Add to calendar' },
  manage: { az: 'Bronu idarə et', ru: 'Управлять записью', en: 'Manage booking' },
  newTime: { az: 'Yeni vaxt', ru: 'Новое время', en: 'New time' },
  'check.name': { az: 'Adınızı daxil edin', ru: 'Укажите имя', en: 'Enter your name' },
  'check.phone': { az: 'Telefon nömrəsini yoxlayın', ru: 'Проверьте номер телефона', en: 'Check the phone number' },
  'check.email': { az: 'E-poçt ünvanını yoxlayın', ru: 'Проверьте адрес эл. почты', en: 'Check the e-mail address' },
  branch: { az: 'Filial', ru: 'Отделение', en: 'Branch' },
  service: { az: 'Xidmət', ru: 'Услуга', en: 'Service' },
  day: { az: 'Gün', ru: 'День', en: 'Day' },
  time: { az: 'Vaxt', ru: 'Время', en: 'Time' },
  name: { az: 'Ad, soyad', ru: 'Имя', en: 'Name' },
  fin: { az: 'FİN', ru: 'ФИН', en: 'FIN' },
  sms: { az: 'SMS', ru: 'SMS', en: 'SMS' },
  email: { az: 'E-poçt', ru: 'Эл. почта', en: 'E-mail' },
  phone: { az: 'Telefon', ru: 'Телефон', en: 'Phone' },
  address: { az: 'E-poçt ünvanı', ru: 'Адрес эл. почты', en: 'E-mail address' },
  back: { az: 'Geri', ru: 'Назад', en: 'Back' },
  book: { az: 'Bron et', ru: 'Записаться', en: 'Book' },
  code: { az: 'Təsdiq kodu', ru: 'Код подтверждения', en: 'Confirmation code' },
  confirm: { az: 'Təsdiqlə', ru: 'Подтвердить', en: 'Confirm' },
  resend: { az: 'Yenidən göndər', ru: 'Отправить снова', en: 'Send again' },
  done: { az: 'Bronunuz təsdiqləndi', ru: 'Вы записаны', en: 'You are booked' },
  bookingCode: { az: 'Bron kodu', ru: 'Код записи', en: 'Booking code' },
  free: { az: 'Boş yer: {n}', ru: 'Свободно: {n}', en: '{n} free' },
  full: { az: 'Dolu', ru: 'Занято', en: 'Full' },
  none: { az: 'Boş vaxt yoxdur', ru: 'Нет свободного времени', en: 'No free time' },
  noDays: { az: 'Boş gün yoxdur', ru: 'Нет свободных дней', en: 'No free days' },
  cancel: { az: 'Ləğv et', ru: 'Отменить', en: 'Cancel' },
  cancelAsk: { az: 'Bron ləğv edilsin?', ru: 'Отменить запись?', en: 'Cancel this booking?' },
  keep: { az: 'Saxla', ru: 'Оставить', en: 'Keep' },
  cancelled: { az: 'Ləğv edildi', ru: 'Отменено', en: 'Cancelled' },
  move: { az: 'Vaxtı dəyiş', ru: 'Перенести', en: 'Move' },
  moved: { az: 'Vaxt dəyişdi', ru: 'Перенесено', en: 'Moved' },
  error: { az: 'Alınmadı', ru: 'Не получилось', en: 'That did not work' },
  'problem.SLOT_FULL': { az: 'Bu vaxtda yer qalmayıb', ru: 'На это время мест нет', en: 'That time is full' },
  'problem.SLOT_NOT_OFFERED': { az: 'Bu vaxt artıq yoxdur', ru: 'Это время уже недоступно', en: 'That time is no longer offered' },
  'problem.BOOKING_NOT_OFFERED': { az: 'Bron təklif edilmir', ru: 'Запись недоступна', en: 'Booking is not offered' },
  'problem.MODULE_NOT_LICENSED': { az: 'Bron təklif edilmir', ru: 'Запись недоступна', en: 'Booking is not offered' },
  'problem.TOO_MANY_OPEN': { az: 'Sizin artıq bronlarınız var', ru: 'У вас уже есть записи', en: 'You already have bookings' },
  'problem.FIN_REQUIRED': { az: 'FİN daxil edin', ru: 'Укажите ФИН', en: 'Enter your FIN' },
  'problem.FIN_SHAPE': { az: 'FİN 7 hərf və rəqəmdir', ru: 'ФИН — 7 букв и цифр', en: 'A FIN is 7 letters and digits' },
  'problem.CONTACT_SHAPE': { az: 'Telefonu və ya ünvanı yoxlayın', ru: 'Проверьте телефон или адрес', en: 'Check the phone or address' },
  'problem.CHANNEL_UNAVAILABLE': { az: 'Bu üsul əlçatan deyil', ru: 'Этот способ недоступен', en: 'That way is not available' },
  'problem.CODE_WRONG': { az: 'Kod səhvdir. Qalan cəhd: {left}', ru: 'Неверный код. Осталось попыток: {left}', en: 'Wrong code. Tries left: {left}' },
  'problem.HOLD_EXPIRED': { az: 'Vaxt bitdi. Yenidən bron edin', ru: 'Время истекло. Запишитесь снова', en: 'Time is up. Book again' },
  'problem.TOO_LATE_TO_CHANGE': { az: 'Artıq dəyişmək olmaz', ru: 'Изменить уже нельзя', en: 'Too late to change' },
  'problem.NOT_BOOKED': { az: 'Bu bronu artıq dəyişmək olmaz', ru: 'Эту запись уже не изменить', en: 'This booking cannot change' },
  'problem.RATE_LIMITED': { az: 'Bir azdan yenidən cəhd edin', ru: 'Попробуйте чуть позже', en: 'Try again shortly' },
  'problem.RATE_LIMITED.codes': { az: 'Çox kod göndərilib. {minutes} dəq sonra cəhd edin', ru: 'Слишком много кодов. Повторите через {minutes} мин', en: 'Too many codes sent. Try again in {minutes} min' },
  'problem.TOO_MANY_HOLDS': { az: 'Bir neçə dəqiqədən sonra yenidən cəhd edin', ru: 'Повторите через несколько минут', en: 'Try again in a few minutes' },
  'problem.RESEND_LIMIT': { az: 'Kod həddindən çox göndərilib', ru: 'Код отправлен слишком много раз', en: 'The code was sent too often' },
  'problem.ALREADY_CONFIRMED': { az: 'Bron artıq təsdiqlənib', ru: 'Запись уже подтверждена', en: 'Already confirmed' },
  'problem.NO_SUCH_BOOKING': { az: 'Bron tapılmadı', ru: 'Запись не найдена', en: 'Booking not found' },
  'problem.BOOKING_ENDED': { az: 'Bu bron artıq bitib', ru: 'Эта запись уже завершена', en: 'This booking has ended' },
  'problem.BOOKING_KEY': { az: 'Test səhifəsi söndürülüb', ru: 'Тестовая страница выключена', en: 'The test page is off' },
  'problem.DAY_FULL': { az: 'Bu gün üçün yer qalmayıb', ru: 'На этот день мест нет', en: 'That day is fully booked' },
  'problem.FIELD_REQUIRED': { az: '{field} daxil edin', ru: 'Заполните: {field}', en: 'Fill in {field}' },
  'problem.FIELD_SHAPE': { az: '{field} yoxlayın', ru: 'Проверьте: {field}', en: 'Check {field}' },
  'problem.BOOKING_BLOCKED': {
    az: 'Çox bron buraxılıb. {until} tarixindən bron edin',
    ru: 'Слишком много пропусков. Запись снова с {until}',
    en: 'Too many missed bookings. Book again from {until}',
  },
  'check.required': { az: 'Bu sahə mütləqdir', ru: 'Обязательное поле', en: 'This is required' },
  'check.value': { az: 'Bunu yoxlayın', ru: 'Проверьте значение', en: 'Check this' },
  changeUntil: { az: 'Dəyişmək olar:', ru: 'Изменить можно до', en: 'Changes until' },
  changeClosed: { az: 'Bronu artıq dəyişmək olmaz', ru: 'Запись уже нельзя изменить', en: 'Changes are closed' },
  choose: { az: 'Seçin', ru: 'Выберите', en: 'Choose' },
} satisfies Record<string, Record<Written, string>>

export type WordKey = keyof typeof WORDS

export function say(key: WordKey, lang: Lang, vars?: Record<string, string | number>): string {
  const word: Record<Written, string> = WORDS[key]
  return sayWord(`book.${key}`, lang, word.en, vars, lang === 'az' || lang === 'ru' ? word[lang] : undefined)
}
